export default "__VITE_ASSET__BFb3mPVR__"